<div class="app-cve-container">
  <ng-container>
    <pt-details-layout
      [showNoData]="!appDetails.securityToolType"

      [margin]="'10px 0 10px 0'"
      [title]="'PAGE.APPLICATIONS.DETAILS.CVE_TITLE' | translate">

      <ng-container noDataSuffix>
        <div class="alert alert-info p-2" style="margin: 0 -15px 0 -4px !important">
          {{ 'MESSAGE.VULNERABILITY' | translate }}
        </div>
      </ng-container>

      <ng-container titleSuffix>
        <button (click)="configureCVE()"
                class="btn btn-link btn-sm btn-configure">
          {{ 'LABELS.CONFIGURE' | translate }}
        </button>
      </ng-container>

      <ng-container titleDescription>

      </ng-container>

      <ng-container body>

        <pt-details-application-vulnerability-cvs-severity
          *ngIf="appDetails.securityToolType"
          [cveSeverity]="appDetails?.latestScan?.cveSeverity"
          class="w-100">
        </pt-details-application-vulnerability-cvs-severity>

        <div *ngIf="appDetails.securityToolType" class="app-vulnerability-container m-0">
          <div class='attribute'>
            <div class='key'>{{ 'PAGE.APPLICATIONS.DETAILS.LATEST_SCAN' | translate }}</div>
            <div class="value">{{
                appDetails?.latestScan?.scanAt | localizedDate: {
                  pattern: dateFormat,
                  defaultValue: ND
                }
              }}
            </div>
          </div>

          <div class='attribute'>
            <div *ngIf="appDetails?.latestAudit?.createdAt"
                 class='key'>{{ 'PAGE.APPLICATIONS.DETAILS.NEW_VULNERABILITIES' | translate }}
            </div>

            <div *ngIf="!appDetails?.latestAudit?.createdAt"
                 class='key'>{{ 'PAGE.APPLICATIONS.DETAILS.NEW_VULNERABILITIES_NO_AUDIT' | translate }}
            </div>

            <div [class.text-danger]="appDetails.latestScan?.newCve > 0" class="value">
              <pt-icon class="d-flex align-items-center" *ngIf="appDetails.latestScan?.newCve > 0" [key]='IconWarning'
                       [size]="14"></pt-icon>
              <div class="d-flex align-items-center">{{ appDetails.latestScan?.newCve || '0' }}</div>
            </div>

          </div>

          <div class='attribute'>
            <div class='key'>
              {{ 'PAGE.APPLICATIONS.DETAILS.LATEST_AUDIT' | translate }}
              (
              <button (click)="openAuditDialog.emit()"
                      class="btn btn-link btn-sm btn-configure m-0 font-13">
                {{ 'BUTTON.UPDATE' | translate }}
              </button>
              )
            </div>
            <div *ngIf="appDetails?.latestAudit?.createdAt" class="value">
              {{ appDetails?.latestAudit?.createdAt | localizedDate: { pattern: dateFormat, defaultValue: ND } }}
              (<a (click)='navigateToUser(appDetails?.latestAudit?.authorId)'
                  class='btn btn-link btn-attribute text-link'>
              {{ appDetails?.latestAudit?.authorUsername }}
            </a>)
            </div>
            <div *ngIf="!appDetails.latestAudit?.createdAt" class="value">
              -
            </div>
          </div>

          <div class='attribute'>
            <div class='key'>
              {{ 'PAGE.APPLICATIONS.DETAILS.AUDIT_RESULT' | translate }}
            </div>
            <div class="value">
              <span *ngIf="!appDetails.latestAudit">
                {{ 'LABELS.NO_AUDIT' | translate}}
              </span>
            </div>
          </div>
        </div>

        <!--        <div *ngIf="!audit?.impactMetrics" class="d-flex flex-column w-100">-->
        <!--          {{ "PAGE.APPLICATIONS.DETAILS.NO_VULNERABILITY_AUDITS" | translate }}-->
        <!--        </div>-->
        <pt-rid-viewer
          *ngIf="appDetails.latestAudit"
          [impactMetricsLabels]="appDetails.latestAudit?.impactMetricsLabels"
          [impactMetrics]="appDetails.latestAudit?.impactMetrics"
          [minWidth]="'30%'"
          [withTransaction]="false"
          class="w-100"
          style="margin: 0 auto 10px auto">
        </pt-rid-viewer>
      </ng-container>
    </pt-details-layout>
  </ng-container>
</div>
